import _isObject from 'lodash/isObject';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _max from 'lodash/max';
import {
  getGiftTable,
  deleteGiftTable as deleteGiftTableService,
  getGiftTableWap,
} from 'services/giftTable';
import {
  deleteProductGiftTable,
  getGiftTable as getGiftTableInfo,
  updateGiftTable as patchGiftTable,
} from 'services/api/table';
import { getProductsWithPagination } from 'services/gifts';
import {
  showLoader,
  hideLoader,
  showErrorResponseModal,
  showSuccessResponseModal,
} from 'store/actions/commons';
import { isMobile } from 'util/screen';
import { CURRENT_GIFT_TABLE, PROFILE_DATA, TOTAL_GIFT_TABLES, TOTAL_GIFT_TABLES_OPEN, TOTAL_GIFT_TABLES_CLOSED} from 'constants/storage64';
import {
  decodeStorage,
  removeStorage,
  decodeStorageLatin,
  encodeStorageLatin,
  encodeStorage
} from 'functions/storageBase64';
import {
  addProductToProductsList,
  deleteProductToProductsList,
  orderProductsByRule,
} from 'util/products';
import { calculateTotalPages, getPaginationProps } from 'util/calculations';
import { updateVariantIdIfChanged } from 'util/giftTable';
import {
  fetchExternalGiftTableInfoFailed,
  fetchExternalGiftTableInfoSuccess,
} from 'store/actions/externalGiftTable';
import { FETCH_GIFT_TABLE_INFO as FETCH_EXTERNAL_GIFT_TABLE_INFO } from 'store/actions/externalGiftTable/types';
import { getListOfProductsIds } from 'services/gifts/transformers';
import { getGiftsReceived } from 'services/giftsReceived';
import { getElectronicWallet } from 'services/electronicWallet';
import {
  SET_GIFT_SEARCH_VALUES,
  FETCH_GIFTS_TABLES,
  FETCH_GIFTS_TABLES_SUCCESS,
  FETCH_GIFTS_TABLES_FAILED,
  FETCH_MY_GIFTS_TABLES,
  FETCH_MY_GIFTS_TABLES_SUCCESS,
  FETCH_MY_GIFTS_TABLES_FAILED,
  FETCH_GIFT_TABLE_INFO,
  FETCH_GIFT_TABLE_INFO_SUCCESS,
  FETCH_GIFT_TABLE_INFO_FAILED,
  SET_TABLE_INFO,
  FETCH_GIFT_TABLE_PRODUCTS,
  FETCH_GIFT_TABLE_PRODUCTS_SUCCESS,
  FETCH_GIFT_TABLE_PRODUCTS_FAILED,
  CHANGE_GIFT_TABLE_PRODUCTS_PAGE,
  ADD_PRODUCT,
  DELETE_PRODUCT,
  CHANGE_GIFT_TABLE_PRODUCTS_SORT,
  DELETE_GIFT_TABLE,
  DELETE_GIFT_TABLE_SUCCESS,
  DELETE_GIFT_TABLE_FAILED,
  UPDATE_GIFT_TABLE,
  UPDATE_GIFT_TABLE_SUCCESS,
  UPDATE_GIFT_TABLE_FAILED,
  SET_GIFT_TABLE,
  REMOVE_GIFT_TABLE,
  REDIRECT_AND_RESET,
  FETCH_RECEIVED_GIFTS_SUCCESS,
  FETCH_RECEIVED_GIFTS_FAILED,
  FETCH_ELECTRONIC_TABLE_INFO_SUCCESS,
  FETCH_ELECTRONIC_TABLE_INFO_FAILED,
} from './types';

export const setGiftTableSearchValues = (payload) => ({
  type: SET_GIFT_SEARCH_VALUES,
  payload,
});

export const fetchGiftsTableSuccess = (payload) => ({
  type: FETCH_GIFTS_TABLES_SUCCESS,
  payload,
});

export const fetchGiftsTableFailed = (payload) => ({
  type: FETCH_GIFTS_TABLES_FAILED,
  payload,
});

export const fetchGiftsTables =
  (payload = {}) =>
  async (dispatch) => {
    dispatch(showLoader());

    dispatch({ type: FETCH_GIFTS_TABLES, payload });

    const giftTableInitial = {
      list: [],
      mobileList: [],
      totalElements: 0,
      totalPages: 0,
      params: { page: 0, size: 0, mobilePage: 0, mobileSize: 0 }
    };
    let giftsTables = giftTableInitial;
    let errorGiftTable = false;

    try {
      console.log('1------- fetchGiftsTables: ', payload)
      giftsTables = await getGiftTable(payload);
      giftsTables = +giftsTables.totalPages < payload.page ? giftTableInitial : giftsTables;
    } catch (error) {
      errorGiftTable = true;
      dispatch(fetchGiftsTableFailed(error));
    };

    try {
      /*
      // Se comenta giftsTablesWap paar que no muestre mas de 20 en el listado
      const giftsTablesWap = [12,13,14,15,16,17,18,20,21,22].includes(payload.type_id)
        ? giftTableInitial : await getGiftTableWap(payload);
        console.clear();
      console.log('giftsTablesWap', giftsTablesWap);
      */
      const giftsTablesWap = [];
      const allGiftTables = {
        list: [...giftsTables.list, ...giftsTablesWap.list],
        mobileList: [...giftsTables.list, ...giftsTablesWap.list],
        totalElements: _max([giftsTables.totalElements, giftsTablesWap.totalElements]),
        totalPages: _max([giftsTables.totalPages, giftsTablesWap.totalPages]),
        params: {
            page: _max([giftsTables.params.page, giftsTablesWap.params.page]),
            size: giftsTables.params.page > giftsTablesWap.params.page ? giftsTables.params.size : giftsTablesWap.params.size,
            mobilePage: _max([giftsTables.params.page, giftsTablesWap.params.page]),
            mobileSize: giftsTables.params.page > giftsTablesWap.params.page ? giftsTables.params.size : giftsTablesWap.params.size,
        }
      }

      // console.log(',,,,,,,,,,,,,,,,,,,,,,,')
      // console.log('giftsTables: ',giftsTables)
      // console.log('allGiftTables: ',allGiftTables)
      // console.log(',,,,,,,,,,,,,,,,,,,,,,,')


      dispatch(fetchGiftsTableSuccess(allGiftTables));
    } catch (error) {
      !errorGiftTable && dispatch(fetchGiftsTableSuccess(giftsTables));
      errorGiftTable && dispatch(fetchGiftsTableFailed(error));
    } finally {
      dispatch(hideLoader());
    };
  };

export const fetchMyGiftsTables =
  ({ withLoader = true, withModalError = true, ...payload } = {}) =>
  async (dispatch) => {
    if (withLoader) dispatch(showLoader());
    dispatch({ type: FETCH_MY_GIFTS_TABLES, payload });
    try {
      const profileData = decodeStorage(PROFILE_DATA);
      if (profileData) {
        const params = {
          customer_sears_id: profileData ? profileData.idClaro : '',
          page: payload.page || 1
        };
        // console.log('*****************************')
        // console.log('/-------fetchMyGiftsTables: ',params)
        const giftsTables = await getGiftTable(params);
        const giftTablesTotal = giftsTables?.list?.length ? giftsTables?.list?.length : 0;
        const giftTablesTotalOpen = giftsTables?.list?.filter((gift) => gift.estatus === 'Open').length;
        const giftTablesTotalClose = giftTablesTotal-giftTablesTotalOpen;
        //    console.log('giftTablesTotal asincrono', giftTablesTotal);


        // console.log('/-------fetchMyGiftsTables  giftsTables: ',giftsTables)
        
        
        
        encodeStorage(TOTAL_GIFT_TABLES, giftTablesTotal);
        encodeStorage(TOTAL_GIFT_TABLES_OPEN, giftTablesTotalOpen);
        encodeStorage(TOTAL_GIFT_TABLES_CLOSED, giftTablesTotalClose);
        if(giftTablesTotalOpen === 0 && giftTablesTotalClose>0){
          // si no hay una mesa activa entonces seteamos la primera del listado de mesas
          const giftTableInfo = await getGiftTableInfo(giftsTables.list[0].id, true, false);
          giftTableInfo.evento = giftTableInfo.id;
          giftTableInfo.welcome_message = giftTableInfo.welcome_message || '';


          // console.log('/-------fetchMyGiftsTables  giftTableInfo: ',giftTableInfo)
          
          dispatch(setGiftTable(giftTableInfo));
          encodeStorageLatin(CURRENT_GIFT_TABLE, giftTableInfo);
        }
        dispatch(fetchMyGiftsTablesSuccess(giftsTables));
      }
    } catch (error) {
      if (withModalError) dispatch(showErrorResponseModal(error));
      dispatch(fetchGiftsTableFailed(error));
    } finally {
      if (withLoader) dispatch(hideLoader());
    }
  };

export const fetchSearchMyGiftsTables =
  ({ withLoader = true, withModalError = true, valuesSearch = [], pageParam = 1 , ...payload } = {}) =>
  async (dispatch) => {
    if (withLoader) dispatch(showLoader());
    dispatch({ type: FETCH_MY_GIFTS_TABLES, payload });
    try {
      const profileData = decodeStorage(PROFILE_DATA);
      if (valuesSearch) {
        valuesSearch.customer_sears_id = profileData ? profileData.idClaro : '';
        valuesSearch.page = pageParam;

        // console.log('fetchSearchMyGiftsTables params', valuesSearch);
        const giftsTables = await getGiftTable(valuesSearch);
        const giftTablesTotal = giftsTables?.list?.length ? giftsTables?.list?.length : 0;

        encodeStorage(TOTAL_GIFT_TABLES, giftTablesTotal);
        dispatch(fetchMyGiftsTablesSuccess(giftsTables));
      }
    } catch (error) {
      // console.log('withModalError', withModalError);
      if (withModalError === true) {

        const notFound = {
          message: 'No se encontraron mesas',
          title: 'Error',
        }
        // dispatch(showErrorResponseModal(notFound));
        dispatch(fetchGiftsTableFailed(error));
        // console.log('fetchSearchMyGiftsTables error', error);
      }
    } finally {
      if (withLoader) dispatch(hideLoader());
    }
  };

export const fetchMyGiftsTablesSuccess = (payload) => ({
  type: FETCH_MY_GIFTS_TABLES_SUCCESS,
  payload,
});

export const fetchMyGiftsTablesFailed = (payload) => ({
  type: FETCH_MY_GIFTS_TABLES_FAILED,
  payload,
});

export const fetchGiftTableInfoSuccess = (payload) => ({
  type: FETCH_GIFT_TABLE_INFO_SUCCESS,
  payload,
});

export const fetchGiftTableInfoFailed = (payload) => ({
  type: FETCH_GIFT_TABLE_INFO_FAILED,
  payload,
});

/* Esta cosa al parecer es la que hace peticiones */
export const fetchGiftTableInfo =
  (payload) => async (dispatch, state, history) => {
    dispatch(showLoader());

    // console.log('---------------')
    // console.log('--------fetchGiftTableInfo-------')
    // console.log('---------------')

    let tableId = '';
    let isExternal = false;

    const isObject = _isObject(payload);

    if (isObject) {
      isExternal = Boolean(payload.isExternal);
      tableId = payload.id;
    } else tableId = payload;

    const type = isExternal
      ? FETCH_EXTERNAL_GIFT_TABLE_INFO
      : FETCH_GIFT_TABLE_INFO;

    const successAction = isExternal
      ? fetchExternalGiftTableInfoSuccess
      : fetchGiftTableInfoSuccess;
    const failedAction = isExternal
      ? fetchExternalGiftTableInfoFailed
      : fetchGiftTableInfoFailed;

    dispatch({ type, payload });

    try {
      if(tableId){
        // console.log('fetchGiftTableInfo: ',tableId)

      }
      const giftTableInfo = await getGiftTableInfo(tableId, true, isExternal);

      giftTableInfo.evento = giftTableInfo.id;
      giftTableInfo.welcome_message = giftTableInfo.welcome_message || '';
      giftTableInfo.daniel = true;

      // console.log('isExternal',isExternal);
      
      // This action of fetch products is responsible of hide the loader if it is not external
      if (!isExternal) {
        const currentGiftTableInfo = _get(state, 'giftTable.giftTable', {});
        // console.log('currentGiftTableInfo', currentGiftTableInfo);
        // console.log("_isEmpty",_isEmpty(currentGiftTableInfo))
        if (_isEmpty(currentGiftTableInfo)) {
          dispatch(setGiftTable(giftTableInfo));
        }

        // console.log('giftTableInfo', giftTableInfo);
        
        encodeStorageLatin(CURRENT_GIFT_TABLE, giftTableInfo);

        dispatch(
          fetchGiftTableProducts({
            gifts: giftTableInfo.gifts,
            withLoader: isObject ? payload.withLoader : true,
            tableId
          })
        );
      }
      dispatch(successAction(giftTableInfo));
    } catch (error) {
      if (isExternal) {
        const notFound = error.response.status === 404;
        if (notFound) {
          history.push('/my-table');
          window.location.reload();
        }
      }
      dispatch(failedAction(error));
      dispatch(hideLoader());
    } finally {
      dispatch(hideLoader());
    }
  };

export const fetchReceivedGifts = (giftTable, allOrders) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const data = await getGiftsReceived(giftTable, allOrders);

    // console.log('-------,,,,,')
    // console.log('fetchReceivedGifts: ',data)
    // console.log('-------,,,,,')
    dispatch(fetchReceivedGiftsSuccess(data));
  } catch (e) {
    fetchReceivedGiftsFailed(e.response.message);
    dispatch(hideLoader());
  } finally {
    dispatch(hideLoader());
  }
};

export const fetchReceivedGiftsSuccess = (payload) => ({
  type: FETCH_RECEIVED_GIFTS_SUCCESS,
  payload,
});

export const fetchReceivedGiftsFailed = (payload) => ({
  type: FETCH_RECEIVED_GIFTS_FAILED,
  payload,
});

export const fetchElectronicWalletInfo = (payload, agentToken = null) => async (dispatch) => {
  dispatch(showLoader());
  try {
    const data = await getElectronicWallet(payload, agentToken);
    dispatch(fetchElectronicTableInfoSuccess(data));
  } catch (e) {
    fetchElectronicTableInfoFailed(e.response.message);
    dispatch(hideLoader());
  } finally {
    dispatch(hideLoader());
  }
};

export const fetchElectronicTableInfoSuccess = (payload) => ({
  type: FETCH_ELECTRONIC_TABLE_INFO_SUCCESS,
  payload,
});

export const fetchElectronicTableInfoFailed = (payload) => ({
  type: FETCH_ELECTRONIC_TABLE_INFO_FAILED,
  payload,
});

export const setTableInfo = (payload) => ({
  type: SET_TABLE_INFO,
  payload,
});

export const fetchGiftTableProductsSuccess = (payload) => ({
  type: FETCH_GIFT_TABLE_PRODUCTS_SUCCESS,
  payload,
});

export const fetchGiftTableProductsFailed = (payload) => ({
  type: FETCH_GIFT_TABLE_PRODUCTS_FAILED,
  payload,
});

export const fetchGiftTableProducts =
  ({ withLoader = true, gifts, tableId, ...payload } = {}) =>
  async (dispatch, state) => {
    if (withLoader) dispatch(showLoader());

    const { giftTableInfo = {} } = state.giftTable;

    let listOfGifts = gifts || giftTableInfo.data?.gifts;

    if (!listOfGifts) {
      dispatch(hideLoader());
      return;
    }

    const params = {
      table_id: tableId,
      product_id: 'product_id',
      variant_id: 'variant_id',
      children_sku: 'children_sku',
    }
    listOfGifts = await updateVariantIdIfChanged(listOfGifts, params);

    dispatch({ type: FETCH_GIFT_TABLE_PRODUCTS, payload });

    const allElements = listOfGifts.map((gift) => ({
      ...gift,
      quantity: gift.amount,
      id: gift.product_id,
    }));
    const allProducts = getListOfProductsIds(listOfGifts);

    try {
      const products = await getProductsWithPagination({
        allProducts,
        tableInfoProducts: listOfGifts,
      });

      products.allElements = allElements;

      dispatch(fetchGiftTableProductsSuccess(products));
    } catch (error) {
      dispatch(fetchGiftTableProductsFailed(error));
      dispatch(hideLoader());
    } finally {
      if (withLoader) dispatch(hideLoader());
    }
  };

export const changeGiftTableProductsPage =
  (payload) => async (dispatch, state) => {
    try {
      dispatch(showLoader());

      const params = _get(state, 'giftTable.giftTableProducts.params', {});

      const newParams = {
        ...params,
        ...payload,
      };

      const allElements = _get(
        state,
        'giftTable.giftTableProducts.results.allElements',
        []
      );
      const allProducts = getListOfProductsIds(allElements);
      const tableInfoProducts = _get(
        state,
        'giftTable.giftTableInfo.data.gifts',
        []
      );

      const productsWithPagination = await getProductsWithPagination({
        allProducts,
        params: newParams,
        tableInfoProducts,
      });

      productsWithPagination.allElements = allElements;

      dispatch({
        type: CHANGE_GIFT_TABLE_PRODUCTS_PAGE,
        payload: productsWithPagination,
      });
    } catch (error) {
      dispatch(fetchGiftTableProductsFailed(error));
    } finally {
      dispatch(hideLoader());
    }
  };


 /* provemos add product */ 
export const addProduct = (payload) => async (dispatch, state) => {
  const allElements = _get(
    state,
    'giftTable.giftTableProducts.results.allElements',
    []
  );

  const newAllElements = addProductToProductsList(payload, allElements);

  dispatch({
    type: ADD_PRODUCT,
    payload: { allElements: newAllElements },
  });

  const onError = () =>
    dispatch({
      type: ADD_PRODUCT,
      payload: { allElements },
    });

  const gifts = newAllElements.map((product) => ({
    product_id: Number(product.id),
    quantity: product.quantity,
    ean: product.ean,
    sku: product.sku,
    children_sku: product.children_sku,
    variant_id: product.variant_id,
  }));

  // console.log('-------------------------------')
  // console.log('addProduct.....: ')
  // console.log('payload: ', payload)
  // console.log('allElements: ', allElements)
  // console.log('newAllElements: ',newAllElements)
  // console.log('gifts: ',gifts)
  // console.log('-------------------------------')

  /* al parecer este es el que actualiza el estado */
  return await dispatch(
    updateGiftTable({
      gifts,
      withLoader: false,
      notRefreshInfo: true,
      onError,
    })
  );


};

export const deleteProduct = (payload) => async (dispatch, state) => {
  const {
    list: products = [],
    mobileList: mobileProducts = [],
    allElements,
  } = state.giftTable.giftTableProducts.results;
  const { tableId, productId } = payload;

  try {
    dispatch(showLoader());
    await deleteProductGiftTable(tableId, productId);
    const newAllelements = deleteProductToProductsList(
      { id: productId },
      allElements
    );
    const newList = deleteProductToProductsList({ id: productId }, products);
    const newMobileList = deleteProductToProductsList(
      { id: productId },
      mobileProducts
    );
    const newTotalElements =
      state.giftTable.giftTableProducts.totalElements - 1;

    dispatch({
      type: DELETE_PRODUCT,
      payload: {
        list: newList,
        mobileList: newMobileList,
        allElements: newAllelements,
        totalElements: newTotalElements,
        totalPages: calculateTotalPages(
          newTotalElements,
          state.giftTable.giftTableProducts.params.size
        ),
      },
    });
    dispatch(hideLoader());
    return true;
  } catch (e) {
    dispatch(hideLoader());
    dispatch(showErrorResponseModal(e));
    return false
  }
};

export const changeGiftTableProductsSort = (payload) => (dispatch, state) => {
  const { results = {}, params = {} } = state.giftTable.giftTableProducts;
  const { list: products = [] } = results;

  const pagination = getPaginationProps(
    isMobile() ? results.mobileList : results.list,
    params.size,
    params.page
  );

  const orderProducts = orderProductsByRule(products, payload, pagination.list);

  dispatch({
    type: CHANGE_GIFT_TABLE_PRODUCTS_SORT,
    payload: { list: orderProducts },
  });
};

export const deleteGiftTableSuccess = (payload) => ({
  type: DELETE_GIFT_TABLE_SUCCESS,
  payload,
});

export const deleteGiftTableFailed = (payload) => ({
  type: DELETE_GIFT_TABLE_FAILED,
  payload,
});

export const deleteGiftTable =
  ({ onSuccess, ...payload }) =>
  (dispatch) => {
    dispatch(showLoader());

    dispatch({ type: DELETE_GIFT_TABLE, payload });

    const SUCCESS_MESSAGE = `Tu mesa fue cancelada correctamente, Gracias por confiar en nosotros para formar parte de tus momentos más importantes.
    `;

    deleteGiftTableService(payload)
      .then((response) => {
        dispatch(
          showSuccessResponseModal({
            title: 'Gracias',
            message: SUCCESS_MESSAGE,
            action: redirectAndReset,
          })
        );
        dispatch(deleteGiftTableSuccess(response));
        if (onSuccess) onSuccess();
      })
      .catch((error) => {
        dispatch(showErrorResponseModal(error));
        dispatch(deleteGiftTableFailed(error));
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  };


  /* update */
export const updateGiftTable =
  ({
    onSuccess,
    onError,
    giftTableEvent = '',
    withLoader = false,
    notRefreshInfo = false,
    ...payload
  } = {}) =>
  async (dispatch) => {
    const giftTableOfStorage = decodeStorageLatin(CURRENT_GIFT_TABLE);

    if (withLoader) dispatch(showLoader());

    dispatch({ type: UPDATE_GIFT_TABLE, payload });

    // console.log('-------------------------------')
    // console.log('updateGiftTable.....: ')
    // console.log('payload: ', payload)
    // console.log('giftTableOfStorage: ', giftTableOfStorage)


    try {
      const tableId = giftTableEvent || giftTableOfStorage.evento;
      const giftTableInfo = await patchGiftTable(tableId, payload);
      if (!notRefreshInfo) dispatch(updateGiftTableSuccess(giftTableInfo));
      if (onSuccess) onSuccess(giftTableInfo);
      if (withLoader) dispatch(hideLoader());
      
      // console.log('giftTableInfo: ',giftTableInfo)
      // console.log('-------------------------------')

      return true;
    } catch (e) {
      dispatch(showErrorResponseModal(e));
      dispatch(updateGiftTableFailed(e));
      if (onError) onError(e);
      return false;
    } finally {
      if (withLoader) dispatch(hideLoader());
    }
  };

  /* este es el ue lo actualiza */
export const updateGiftTableSuccess = (payload) => ({
  type: UPDATE_GIFT_TABLE_SUCCESS,
  payload,
});

export const updateGiftTableFailed = (payload) => ({
  type: UPDATE_GIFT_TABLE_FAILED,
  payload,
});

export const setGiftTable = (payload) => ({
  type: SET_GIFT_TABLE,
  payload,
});

export const removeGiftTable = (payload) => ({
  type: REMOVE_GIFT_TABLE,
  payload,
});

export const redirectAndReset =
  ({ closeResponseModal, ...payload }) =>
  (dispatch, _, history) => {
    removeStorage(CURRENT_GIFT_TABLE);

    dispatch(removeGiftTable());
    dispatch({ type: REDIRECT_AND_RESET, payload });
    dispatch(fetchMyGiftsTables());

    history.push('/mis-mesas');

    dispatch(closeResponseModal());
  };

export const resetGiftTable = () => ({
  type: REDIRECT_AND_RESET,
});
